<div class="text-white flex items-center space-x-2">
  <fa-icon [icon]="faCircleCheck" class="text-xl tablet-min:text-2xl text-green-500"></fa-icon>
  <span class="text-sm tablet-min:text-base">
    {{ data.message }}
  </span>
</div>
